module.exports = __webpack_public_path__ + "static/media/xmo.164decb6.svg";